/* lua.js generated code 0.3.0 */

var TreasureBoxBigItem = xClass("TreasureBoxBigItem", cc.Node)

TreasureBoxBigItem.create = function() {
    var self = this
    let b = TreasureBoxBigItem.new()

    b.init()
    return b
}
TreasureBoxBigItem.prototype.init = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    self.setAnchorPoint(0.5, 0.5)
    //yellow bg
    self.bg = cc.Sprite.createWithSpriteFrameName("treasureBox/yellow.png")
    self.addChild(self.bg)
    self.bg.setPosition(0,0)

    self.bubbleBg = cc.Sprite.createWithSpriteFrameName("treasureBox/bubble_bg.png")
    self.addChild(self.bubbleBg)
    self.bubbleBg.setScale(1.29)
    self.bubbleBg.setPosition(0,25)

    //getBtn
    // var getSp = ccui.Scale9Sprite.createWithSpriteFrameName("uilibrary/normal_newergo.png", cc.rect(20,15,10,10))
    // getSp.setPreferredSize(cc.size(135,65))
    var getSp = cc.Sprite.createWithSpriteFrameName("uilibrary/b_blue_cut.png")
    getSp.setScale(0.7,0.6)
    self.getBtn = UIGroupButton.create(getSp)
    self.getBtn.on(UIButtonEvent.Click, function () {
        cc.log("getAward ~~~~!")
        var instance = TreasureBoxManager.getInstance()
        if (instance.isBusy) {
            return
        }
        instance.getBigReward()
        DCAssist.userTrack("redbag", "click_receive_items")
    })
    self.addChild(self.getBtn)
    self.getBtn.setPosition(0, -105)

    //self.limitTag = cc.Sprite.createWithSpriteFrameName("treasureBox/game_prop_bar_time_prop.png")
    self.limitTag = UIItemBuilder.createTimeTag(0, true)
    self.addChild(self.limitTag)
    self.limitTag.setPosition(0,-50)

    var greySp = ccui.Scale9Sprite.createWithSpriteFrameName("uilibrary/disabled_newergo.png", cc.rect(20,15,10,10))
    greySp.setScale9Enabled(true)
    greySp.setPreferredSize(cc.size(135,65))
    self.greyBtn = UIGroupButton.create(greySp)
    self.addChild(self.greyBtn)
    self.greyBtn.setPosition(0, -105)

    self.btnTxt = cc.Label.createWithSystemFont("领取", "Arial", 25)
    self.btnTxt.setAnchorPoint(cc.p(0.5, 0.5))
    self.addChild(self.btnTxt)
    self.btnTxt.setPosition(0, -100)

    self.descTxt = cc.Label.createWithSystemFont("集齐5个红包\n可以领取", "Arial", 20)
    self.descTxt.setAlignment(cc.TEXT_ALIGNMENT_CENTER)
    self.descTxt.setColor(hex2ccc3("0x955A33", 16))  
    self.descTxt.setAnchorPoint(cc.p(0.5, 0.5))
    self.addChild(self.descTxt)
    self.descTxt.setPosition(0, -105)
}

TreasureBoxBigItem.prototype.setData = function(data) {
    var self = this
    self.data = data

    self.showItemIcons(data.bigRewards)
    self.showState()
}
TreasureBoxBigItem.prototype.createNumLabel = function (num) {
    let numLabel = cc.LabelBMFont.create("x" + tostring(num), "font/berlinsansfb_40_dropshadow.fnt")
    numLabel.setAnchorPoint(cc.p(0, 0))
    numLabel.setScale(1)
    return numLabel
}
TreasureBoxBigItem.prototype.showItemIcons = function(arr) {
    var self = this
    var pArr = [cc.p(0,0), cc.p(0,65), cc.p(-40,0), cc.p(40,0),, cc.p(30,30)]
    self.itemArr = []
    for(var i=1;i<arr.length;i++) {
        let info = arr[i]
        let itemIcon = UIItemBuilder.createPropIconWithoutTag(info.itemId)
        // let itemIcon = UIItemBuilder.createPropIcon(info.itemId)
        let itemIconBtn = UIButton.create(itemIcon)
        // itemIconBtn.on(UIButtonEvent.Click, function () {
        //     self.onClick()
        // })
        self.addChild(itemIconBtn)
        itemIconBtn.setPosition(pArr[i])
        itemIconBtn.setScale(0.7)
        let numTxt = self.createNumLabel(info.num)
        numTxt.x = 70
        itemIconBtn.addChild(numTxt)
        self.itemArr.push(itemIconBtn)
    }
}
TreasureBoxBigItem.prototype.hideAll = function() {
    var self = this
    self.descTxt.setVisible(false)
    self.btnTxt.setVisible(false)
    self.getBtn.setVisible(false)
    self.greyBtn.setVisible(false)
}
TreasureBoxBigItem.prototype.showState = function() {
    var self = this
    self.hideAll()
    //不可领取
    var st = self.data.rewardState
    if(st == 0) {
        self.descTxt.setVisible(true)
    }
    //可领取
    else if(st == 1) {
        self.btnTxt.setVisible(true)
        self.btnTxt.setString("领取")
        self.getBtn.setVisible(true)
    }
    //已经领取过
    else if(st == 2) {
        self.greyBtn.setVisible(true)
        self.btnTxt.setVisible(true)
        self.btnTxt.setString("已领取")
    }
}
module.exports = TreasureBoxBigItem
